import { SubmissionError } from 'redux-form';
import fetch from '../../core/fetch';

import messages from '../../locale/messages';
import history from '../../core/history';
import { getListingData } from '../../actions/getListing';
import { manageListingSteps } from '../../actions/manageListingSteps';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import showToaster from '../../helpers/showToaster';
import { createListing as query } from '../../lib/graphql';

async function submit(values, dispatch) {

  let bedTypes, roomType, houseType, bedrooms, buildingSize, bedType, bathroomType;

  bedTypes = JSON.stringify(values?.bedTypes);
  roomType = String(values?.roomType);
  houseType = String(values?.houseType);
  bedrooms = String(values?.bedrooms);
  buildingSize = String(values?.buildingSize);
  bedType = String(values?.bedType);
  bathroomType = String(values?.bathroomType);

  let variables = Object.assign({}, values, {
    bedTypes, roomType, houseType, bedType,
    bedrooms, buildingSize, bathroomType
  });

  // Skip address validation and proceed directly to creating listing
  dispatch(setLoaderStart('location'));

  try {
    const resp = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: query,
        variables: variables
      }),
      credentials: 'include'
    });

    const { data } = await resp.json();

    if (data?.createListing?.status == "success") {
      await dispatch(getListingData(data.createListing.id));
      await dispatch(manageListingSteps(data.createListing.id, 1));
      history.push(data.createListing.id + '/map');
      dispatch(setLoaderComplete('location'));
    } else if (data?.createListing?.status == "notLoggedIn") {
      dispatch(setLoaderComplete('location')); // Stop loader before throwing error
      throw new SubmissionError({ _error: messages.notLoggedIn });
    } else if (data?.createListing?.status == "adminLoggedIn") {
      dispatch(setLoaderComplete('location')); // Stop loader before throwing error  
      throw new SubmissionError({ _error: messages.adminLoggedIn });
    } else {
      dispatch(setLoaderComplete('location'));
      throw new SubmissionError({ _error: messages.somethingWentWrong });
    }
  } catch (error) {
    dispatch(setLoaderComplete('location'));
    if (error instanceof SubmissionError) {
      throw error; // Re-throw submission errors
    } else {
      throw new SubmissionError({ _error: messages.somethingWentWrong });
    }
  }

}

export default submit;
